
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.372 6h-9.767C15.73 6 15 6.703 15 7.571v6.858c0 .867.729 1.571 1.605 1.571h9.767c.9 0 1.628-.704 1.628-1.571V7.57C28 6.703 27.293 6 26.372 6zm-8.546 1.5c.674 0 1.221.528 1.221 1.179 0 .65-.524 1.178-1.22 1.178-.698 0-1.222-.528-1.222-1.178 0-.651.57-1.179 1.221-1.179zm8.52 6.722a.408.408 0 01-.358.207h-8.902a.409.409 0 01-.362-.215.381.381 0 01.033-.41l1.78-2.357a.409.409 0 01.33-.161c.13 0 .252.06.328.161l.826 1.093 2.373-3.415a.387.387 0 01.339-.196c.134 0 .263.065.338.175l3.256 4.714c.083.12.091.274.02.404z","fill":"#fff"}}),_c('rect',{attrs:{"x":"4","y":"6","width":"9","height":"2","rx":"1","fill":"#fff","fill-opacity":".65"}}),_c('rect',{attrs:{"x":"4","y":"10","width":"7","height":"2","rx":"1","fill":"#fff","fill-opacity":".65"}}),_c('rect',{attrs:{"x":"4","y":"14","width":"9","height":"2","rx":"1","fill":"#fff","fill-opacity":".65"}}),_c('rect',{attrs:{"x":"4","y":"18","width":"24","height":"2","rx":"1","fill":"#fff","fill-opacity":".65"}}),_c('rect',{attrs:{"x":"4","y":"22","width":"24","height":"2","rx":"1","fill":"#fff","fill-opacity":".65"}})])
          )
        }
      }
    